export default {
  trackingNumber: 'شماره پیگیری',
  amount: 'مبلغ',
  cash: 'نقدی',
  credit: 'اعتباری',
  internet: 'اینترنتی',
  paymentMethod: 'شیوه پرداخت',
  selectGateway: 'انتخاب درگاه',
  pleaseSelectGateway: 'لطفا درگاه را انتخاب کنید',
  loadPaymentDescription: 'شناسه سفارش {loadId}',
  successfulPaymentMessage: 'پرداخت با موفقیت انجام',
  failedPaymentMessage: 'پرداخت ناموفق',
  payAndSubmitSuccessfulMessage: 'درخواست شما با موفقیت ثبت شد',
  payAndSubmitFailedMessage:
    "به علت عدم پرداخت، درخواست به صورت 'ثبت اولیه' در سیستم ثبت شد",
  feePaid: 'هزینه پرداختی',
  bankTrackingNumber: 'شماره پیگیری بانک',
  loadDetail: 'جزئیات بار',
  payAgain: 'پرداخت مجدد',
  successfulPayment: 'پرداخت موفق',
  failedPayment: 'پرداخت ناموفق',
  payOrder: 'پرداخت سفارش',
  redirectingToPaymentGateway: 'در حال انتقال به درگاه پرداخت ...',
  internetPortal: 'درگاه اینترنتی',
  orgPortal: 'درگاه سازمانی',
  giftCard: 'کارت هدیه',
  enterYourGiftCard: 'کارت هدیه خود را وارد کنید',
  orderAmount: 'مبلغ سفارش',
  directBankTransfer: 'انتقال مستقیم بانکی',
  payCredit: 'افزایش موجودی کیف پول',
  balance: 'موجودی',
  bankCredit: 'اعتبار بانکی',
  pay: 'پرداخت'
}
